import React from 'react';

const Offer = ({ offer }) => {
    const clickLink = (event, link) => {
        event.stopPropagation();
        event.nativeEvent.preventDefault();
        event.nativeEvent.stopImmediatePropagation();
        window.open(link, '_blank');
    }

    return (
        <tr onClick={event => clickLink(event, offer.link)}>
            <td data-title="Job position">{offer.title}</td>
            <td data-title="City">{offer.cityName}</td>
            <td data-title="Business unit">{offer.departmentName}</td>
            <td>
                <a className={'btn-link'} href={offer.link} target={"_blank"} rel={"noopener noreferrer"}>&rarr;</a>
            </td>
        </tr>
    )
};

export default Offer;
